<template lang="pug">
.c-page-header.c-page-header--large.c-page-header--full
  .row
    .column
      h1.c-page-header__headline.c-page-header__headline--big {{$t('landingPage.headline_big')}}
      h2.c-page-header__headline.c-page-header__headline--small {{$t('landingPage.headline_small')}}
  .row.gap.p-list-display
    .column.medium-4.p-list-display__item
      img.p-list-display__image(src='../assets/img/landingPage/white-magnifying-glass.svg')
      p(v-html="$t('landingPage.analyze')")
    .column.medium-4.p-list-display__item
      img.p-list-display__image(src='../assets/img/landingPage/white-shield.svg')
      p(v-html="$t('landingPage.advice')")
    .column.medium-4.p-list-display__item
      img.p-list-display__image(src='../assets/img/landingPage/white-question.svg')
      p(v-html="$t('landingPage.expert')")
  Form
  .row.u-margin-top-8x
    .column.medium-12
      p.p-credits(v-html="$t('landingPage.partnership')")
    .column.medium-12.text-center
      img.u-margin-top-4x(style="max-width: 200px" src='../assets/img/landingPage/dh.png')
</template>

<script>
import Form from './landingPage/Form'

export default {
  components: {
    Form
  },
  created () {
    document.title = 'Seraphin - Check-up'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LandingPage.vue